<template>
    <div class="container contadorcont">
        <h3>Cantidad de usuarios que terminaron el juego</h3>
        <button class="contador">{{totalIngresos}}</button>
    </div>    
</template>

<script>
import  firebaseServices from "@/services/firebaseServices";
import Control from "@/components/Control";
import Fondos from '@/components/Fondos.vue'
import { onMounted } from 'vue';
export default {
    data() {
        return{
            totalIngresos: 0
        }
    },
    components:{
        Control,
        Fondos
    },
     mounted(){
        firebaseServices.Totalfinalizados('usuario').then((res) => {
            this.totalIngresos = res;
            console.log(res);
        });
     }
}
</script>


